module.exports = __webpack_public_path__ + "static/img/wp8_inverseicons.cd3081f.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/spreadsheet/kendoui/images/wp8_inverseicons.png
// module id = 1655
// module chunks = 28